import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import MuiRadioGroup from '@mui/material/RadioGroup';
import React from 'react';

import IconChecked from '../../../assets/radio-checked.svg';
import Icon from '../../../assets/radio.svg';

import styles from './RadioGroup.scss';

interface Props {
  name: string;
  disabled?: boolean;
  defaultValue?: string;
  selectedOption?: string;
  options: { label: string | JSX.Element; value: string }[];
  onChange: FormControlLabelProps['onChange'];
}

const RadioGroup: React.FC<Props> = ({
  name,
  options,
  defaultValue = '',
  selectedOption,
  disabled,
  onChange
}) => (
  <MuiRadioGroup defaultValue={defaultValue} value={selectedOption} name={name}>
    {options.map(({ label, value }) => (
      <FormControlLabel
        disabled={disabled}
        classes={{ disabled: styles.labelDisabled, root: styles.labelRoot }}
        key={value}
        value={value}
        checked={value === selectedOption}
        onChange={onChange}
        control={
          <Radio
            classes={{ checked: styles.checked }}
            icon={<Icon />}
            checkedIcon={<IconChecked />}
          />
        }
        label={label}
      />
    ))}
  </MuiRadioGroup>
);

export default RadioGroup;
